import React from 'react';

import { Typography } from '@mui/material';
import { SelectButton } from 'src/components';
import { CrossReferenceIcon } from 'src/components/icons/CrossReferenceIcon';
import { crossReferenceDialogOpenVar } from 'src/editor';
import { useEditingDisabled } from 'src/store/document/selectors';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  imageText: {
    marginLeft: theme.spacing(0.5),
  },
}));

export function CrossReferenceButton(): JSX.Element {
  const { classes } = useStyles();
  const disabled = useEditingDisabled();

  return (
    <>
      <SelectButton disabled={disabled} onClick={() => crossReferenceDialogOpenVar(true)}>
        <CrossReferenceIcon />
        <Typography className={classes.imageText} color="inherit" variant="caption">
          Cross-reference
        </Typography>
      </SelectButton>
    </>
  );
}
